import { DispatchType, StoreAction } from "../reduxTypes";
import loginService from "../../services/login";
import { Error202, parseError } from "../../utils/http-helper";
import { getSession } from "../../utils/session-helper";

export const SESSION__INIT_LOGIN_STATE = "SESSION__INIT_LOGIN_STATE";
export const SESSION__SET_TEMP_SESSION = "SESSION__SET_TEMP_SESSION";
export const SESSION__SET_SESSION = "SESSION__SET_SESSION";
export const SESSION__START_LOGIN_LOAD = "SESSION__START_LOGIN_LOAD";
export const SESSION__STOP_LOGIN_LOAD = "SESSION__STOP_LOGIN_LOAD";
export const SESSION__MODAL_OPEN = "SESSION__MODAL_OPEN";
export const SESSION__LOGOUT = "SESSION__LOGOUT";

function initLoginState(userData?: Object): StoreAction {
  return {
    type: SESSION__INIT_LOGIN_STATE,
    payload: userData,
  };
}

function setTempSession(userData?: Object): StoreAction {
  return {
    type: SESSION__SET_TEMP_SESSION,
    payload: userData,
  };
}

function setModalOpen(open: boolean): StoreAction {
  return {
    type: SESSION__MODAL_OPEN,
    payload: open,
  };
}

function setSession(): StoreAction {
  return { type: SESSION__SET_SESSION };
}

function startLoginLoad(): StoreAction {
  return { type: SESSION__START_LOGIN_LOAD };
}

function stopLoginLoad(): StoreAction {
  return { type: SESSION__STOP_LOGIN_LOAD };
}

function logout() {
  return { type: SESSION__LOGOUT };
}

function login(userName: string, password: string) {
  return function (dispatch: DispatchType) {
    dispatch(startLoginLoad());

    return loginService
      .login(userName, password)
      .then((resp) => {
        dispatch(stopLoginLoad());
        if (resp.data === null) {
          throw new Error202("Credenciais Inválidas!");
        }

        const data = JSON.stringify(resp.data);
        dispatch(setTempSession(JSON.parse(data)));
        if (!resp.data.DataConsentimentoLGPD_SITE) {
          dispatch(setModalOpen(true));
        } else {
          dispatch(setSession());
        }
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => dispatch(stopLoginLoad()));
  };
}

function aceitarLGPD(userName: string) {
  return function (dispatch: DispatchType) {
    dispatch(startLoginLoad());

    return loginService
      .aceitarPolitica(userName)
      .then((resp) => {
        dispatch(stopLoginLoad());
        dispatch(setSession());
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => {
        dispatch(stopLoginLoad());
        dispatch(setModalOpen(false));
      });
  };
}

function iniciarEstadoLogin() {
  return async function (dispatch: DispatchType) {
    dispatch(startLoginLoad());
    const session = await getSession();
    dispatch(initLoginState(session));
  };
}

const loginActions = {
  iniciarEstadoLogin,
  setTempSession,
  setSession,
  setModalOpen,
  startLoginLoad,
  stopLoginLoad,
  logout,
  login,
  aceitarLGPD,
};

export default loginActions;
